import type { RefObject } from "react";
import { useCallback, useEffect } from "react";

export const useClickOutside = (ref: RefObject<HTMLElement | null>, callback: () => void, isEnabled: boolean) => {
    const handleClick = useCallback(
        (e: MouseEvent) => {
            if (ref.current && !ref.current?.contains(e.target as Node)) {
                callback();
            }
        },
        [ref, callback],
    );

    useEffect(() => {
        if (!isEnabled) {
            return;
        }

        // We need to ignore Alerts button click itself as it's flushed synchronously
        // https://github.com/facebook/react/issues/24657
        setTimeout(() => {
            document.addEventListener("click", handleClick);
        });

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [handleClick, isEnabled]);
};
